import apiClient from "./api";
import { getApiAccessToken } from "./UserService";
import {
  CityObjectExceptionReportType,
  CityObjectExceptionReportUploadPolicyType,
  UploadCityObjectExceptionReportRequest,
} from "../types/CityObjectExceptionReport";

const baseUrl = "/api/CityObjectExceptionReports";

const authHeaders = async () => {
  const token = await getApiAccessToken();
  return { Authorization: `Bearer ${token}` };
};

export const getExceptionReports = async (
  objectId: number,
  contractId: number,
  addressSystemId: number,
  currentUserId: number,
): Promise<CityObjectExceptionReportType[]> => {
  const headers = await authHeaders();
  const response = await apiClient.get<CityObjectExceptionReportType[]>(
    baseUrl,
    {
      headers,
      params: { objectId, contractId, addressSystemId, currentUserId },
    },
  );
  return response.data;
};

export const getUploadPolicy = async (
  objectId: number,
  contractId: number,
  addressSystemId: number,
  currentUserId: number,
): Promise<CityObjectExceptionReportUploadPolicyType> => {
  const headers = await authHeaders();
  const response =
    await apiClient.get<CityObjectExceptionReportUploadPolicyType>(
      `${baseUrl}/upload-policy`,
      {
        headers,
        params: { objectId, contractId, addressSystemId, currentUserId },
      },
    );
  return response.data;
};

export const uploadExceptionReport = async (
  request: UploadCityObjectExceptionReportRequest,
): Promise<{ id: number }> => {
  const headers = await authHeaders();
  const formData = new FormData();
  formData.append("file", request.file);
  formData.append("fileHeader", request.fileHeader);
  formData.append("objectId", String(request.objectId));
  formData.append("contractId", String(request.contractId));
  formData.append("addressSystemId", String(request.addressSystemId));

  const response = await apiClient.post<{ id: number }>(baseUrl, formData, {
    headers,
    params: { currentUserId: request.currentUserId },
  });
  return response.data;
};

export const downloadExceptionReport = async (
  id: number,
  objectId: number,
  contractId: number,
  addressSystemId: number,
  currentUserId: number,
): Promise<Blob> => {
  const headers = await authHeaders();
  const response = await apiClient.get<Blob>(`${baseUrl}/${id}/download`, {
    headers,
    params: { objectId, contractId, addressSystemId, currentUserId },
    responseType: "blob",
  });
  return response.data;
};

export const deleteExceptionReport = async (
  id: number,
  objectId: number,
  contractId: number,
  addressSystemId: number,
  currentUserId: number,
): Promise<void> => {
  const headers = await authHeaders();
  await apiClient.delete(`${baseUrl}/${id}`, {
    headers,
    params: { objectId, contractId, addressSystemId, currentUserId },
  });
};
